import * as fromDatatype from '../datatype-library';

export interface bl_cms_topic_subscription_ext_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_cms_topic_subscription_ext_RowClass implements bl_cms_topic_subscription_ext_RowInterface{
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
